import Drawer, { DrawerProps } from '../../Components/Drawer';
import {
  LeagueRewardsT,
  LeagueT,
} from '../../types';
import LeagueIcon from '../../Components/LeagueIcon';
import { getStarBg, numberWithCommas } from '../../helpers';
import RocketIcon from '../../icons/Rocket';
import Button from '../../Components/Button';
import { useAppDispatch, useAppSelector } from '../../store';
import { claimLeaderboardRewards, getTopLeaguesReward } from '../../store/reducers/leaderboard/asyncActions';
import { getActiveChests } from '../../store/reducers/chests/asyncActions';
import { updateLeague } from '../../store/reducers/store/asyncActions';
import { ChestReward, EnergyReward, RocketCoinsYieldReward } from '../../Components/LeagueRewards';

function LeaguePromotion({
  onClose, open,
}: DrawerProps) {
  const dispatch = useAppDispatch();
  const { activeRewards } = useAppSelector(({ leaderboard }) => leaderboard);
  const { userData } = useAppSelector(({ profile }) => profile);
  const aggregateRewards = (rewardsArray: { rewards: LeagueRewardsT }[]): LeagueRewardsT => rewardsArray.reduce((acc: LeagueRewardsT, reward) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(reward.rewards) as (keyof LeagueRewardsT)[]) {
      acc[key] = (Number(acc[key] || 0)) + (Number(reward.rewards[key] || 0));
    }
    return acc;
  }, {} as LeagueRewardsT);

  const aggregated = aggregateRewards(activeRewards || []);
  const league = userData?.league as LeagueT;
  const handleClaimRewards = async () => {
    if (activeRewards?.length) {
      const ids = activeRewards.map((el) => el.id);
      await dispatch(claimLeaderboardRewards({ ids }));
      dispatch(getTopLeaguesReward());
      dispatch(getActiveChests());
    }
  };
  const handleClose = async () => {
    await handleClaimRewards();
    dispatch(updateLeague());
    onClose?.();
  };
  return (
    <Drawer
      onClose={handleClose}
      open={open}
      side="bottom"
      wrapperClassName="flex flex-col shadow-xl rounded-t-[20px] z-[9] relative overflow-hidden bg-leaguePromotionBG modal-border-gradient pb-[6vh]"
      closeStroke="[#ffffff]"
    >
      <div className="px-4">
        <div className={`mt-8 flex flex-col items-center before:content-[''] 
             ${getStarBg(league?.name)} 
             before:w-screen before:left-0 before:bg-center0 before:h-[50vh] before:absolute before:bg-no-repeat before:top-[-3rem] before:z-[1]`}
        >
          <div className="z-[1] h-fit flex flex-col items-center">
            <div className={{
              Bronze: 'h-[7.115rem] w-[6.938rem] mt-6',
              Silver: 'h-[7.115rem] w-[6.938rem] mt-6',
              Gold: 'h-[7.115rem] w-[6.938rem] mt-6',
              Platinum: 'h-[7.715rem] w-[6.938rem] mt-6 translate-y-[-5px]',
              Diamond: 'h-[7.615rem] w-[6.938rem] mt-6 translate-y-[-5px]',
              Challenger: 'h-[7.115rem] w-[6.938rem] mt-6',
              Legendary: 'h-[8.215rem] w-[6.938rem] mt-6 translate-y-[-10px]',
              Master: 'h-[9.715rem] w-[6.938rem] mt-0 translate-y-[6px]',
            }[league?.name]}
            >
              <LeagueIcon league={league?.name} />
            </div>
          </div>
        </div>
        <div className="text-white mt-10 text-22 font-bold font-Bangers leading-[23.41px]">
          congratulations
        </div>
        <div className="text-white mt-[2px] ml-[-.15rem] text-base font-bold font-Bangers tracking-[0.2px]">
          You were promoted to
          {' '}
          {league?.name}
        </div>
        <div className="text-white mt-[0] mx-auto text-base font-bold font-Bangers flex">
          <div className="mx-auto my-0 flex">
            <RocketIcon size={24} />
            {' '}
            {numberWithCommas(Number((userData?.rocket_coins || 0).toFixed(0)))}
          </div>
        </div>
        <div className="text-gray-2 mt-[2px] mx-auto text-sm font-Barlow">
          You crushed it! Big moves, big wins—now enjoy the goodies you earned
        </div>
        <div
          className="font-normal font-Bangers main-border-gradient bg-leagueCardBg rounded-10 flex items-center justify-between pl-4 pr-2 mt-7"
        >
          <div className="flex items-center">
            <div className={`text-26 font-normal font-Bangers pr-1 text-white
      ${league?.rank === 1 && 'text-transparent bg-clip-text bg-gradient-to-b from-[#FFBB66] to-[#894C00]'}
      ${league?.rank === 2 && 'text-[#A7B7BF]'}
      ${league?.rank === 3 && 'text-[#F27C57]'}
      `}
            >
              #
              {numberWithCommas(league?.rank)}
            </div>
            {!!Object.keys(aggregated).length
            && <div className="text-white mt-[0] ml-1 tracking-[0.2px] text-base font-bold font-Bangers">YOUR REWARD IS</div>}
          </div>
          <div className="flex justify-start gap-1">
            {aggregated.energy
            && <EnergyReward energy={aggregated.energy || 0} />}
            {aggregated.rocket_coins_recovery_per_hour
                && <RocketCoinsYieldReward rocket_coins_recovery_per_hour={aggregated.rocket_coins_recovery_per_hour || 0} />}
            {aggregated.launch_chest
                && <ChestReward chest={aggregated.launch_chest || 0} />}
            {aggregated.orbit_chest
                && <ChestReward chest={aggregated.orbit_chest || 0} />}
          </div>
        </div>
        {(aggregated.launch_chest || aggregated.orbit_chest)
          && (
          <Button
            onClick={handleClose}
            className="btn navy mt-10 py-4 text-[24px] navy-button-gradient-border"
            style={{
              borderWidth: '0px',
            }}
          >
            Open orbit chest
          </Button>
          )}
      </div>
    </Drawer>
  );
}

export default LeaguePromotion;
